{
  "competition_details": "Tävlingsdetaljer",
  "view_coming_soon": "Tävlingsvy kommer snart",
  "player_view_description": "Denna funktion låter dig visa tävlingsdetaljer, anmäla dig till tävlingar och följa dina resultat.",
  "view": {
    "public": "Offentlig",
    "live": "Live",
    "date": "Datum",
    "type": "Typ",
    "description": "Beskrivning",
    "participants": "Deltagare",
    "min_players": "Min: {{count}}",
    "ideal_players": "Mål: {{count}}",
    "features_coming_soon": "Registrerings- och resultattavlefunktioner kommer snart",
    "register": "Anmäl dig",
    "registration_period": "Anmälningstid",
    "start_times": "Starttider",
    "no_participants": "Inga deltagare än",
    "round": "Runda",
    "no_start_times": "Starttider har inte definierats ännu",
    "add_to_calendar": "Lägg till i kalender",
    "notPublic": "Ej offentlig",
    "load_failed": "Evenemanget hittades inte eller dess uppgifter kunde inte laddas."
  },
  "types": {
    "SINGLE": "Individuell tävling",
    "TEAM": "Lagtävling",
    "EVENT": "Evenemang",
    "WEEKLY": "Veckotävling",
    "MATCHPLAY": "Match play"
  },
  "typeDescriptions": {
    "SINGLE": "Individuell tävling där varje spelare spelar sitt eget resultat",
    "TEAM": "Lagtävling där lag med 2-4 spelare tävlar mot varandra.\n\nSpelformer: Greensome, Foursome, Scramble, Bästa boll och Irish Rumble",
    "WEEKLY": "Veckotävling där spelare kan skicka in flera resultat och de bästa resultaten räknas mot slutresultatet",
    "EVENT": "Annat evenemang utan poängberäkning. Till exempel pro-kurs, årsmöte eller klubbresa",
    "MATCHPLAY": "Matchtävling där spelare eller lag spelar mot varandra i bracket- eller ligaformat (kommer snart)"
  },
  "list": {
    "search_placeholder": "Sök tävlingar...",
    "no_competitions_found": "Inga tävlingar hittades",
    "no_competitions_for_search": "Inga tävlingar hittades för \"{{searchTerm}}\" år {{year}}.",
    "no_competitions_for_year": "Inga tävlingar hittades för år {{year}}.",
    "failed_to_load": "Misslyckades att ladda tävlingar",
    "try_again": "Försök igen",
    "click_to_edit": "Klicka för att redigera tävling",
    "create_competition": "Skapa evenemang",
    "has_waitlist": "Evenemanget har deltagare i kö",
    "public_calendar": "Offentlig kalender",
    "show_older": "Visa tidigare",
    "upcoming": "Kommande",
    "all": "Alla"
  },
  "table": {
    "start_date": "Startdatum",
    "name": "Namn",
    "type": "Typ",
    "status": "Status",
    "participants": "Deltagare",
    "courses": "Banor",
    "tenant": "Klubb"
  },
  "form": {
    "selectTypeTitle": "Välj tävlingstyp",
    "tabs": {
      "eventInfo": "Evenemang",
      "series": "Serier",
      "teams": "Lag",
      "participants": "Deltagare",
      "rounds": "Rundor",
      "flights": "Starter",
      "results": "Resultatkort",
      "scoring": "Resultat",
      "matchplay": "Scheman"
    },
    "fields": {
      "name": "Tävlingsnamn",
      "type": "Tävlingstyp",
      "startDate": "Startdatum",
      "endDate": "Slutdatum",
      "description": "Beskrivning",
      "maxParticipants": "Maximalt antal deltagare",
      "registrationOpens": "Registrering öppnar",
      "registrationCloses": "Registrering stängs",
      "min_team_size": "Minsta lagstorlek",
      "max_team_size": "Maximal lagstorlek",
      "competitionImage": "Tävlingsbild",
      "invitation": "Inbjudan",
      "maxScoresPerPlayer": "Maximalt antal resultat",
      "countingScores": "Räknande resultat",
      "themeColor": "Temafärg",
      "cancellationDeadline": "Deadline för avbokning",
      "registrationRestriction": "Tillåt registrering",
      "allowedClubs": "Välj klubbar",
      "publicDescription": "Offentlig beskrivning",
      "chooseThemeColor": "Välj temafärg",
      "allowWaitlist": "Tillåt väntelista",
      "publicUrl": "Offentlig länk",
      "tenant": "Kund",
      "liveScoringHiddenHoles": "Dölj de sista hålen från livescoring-resultaten",
      "participantVisibility": "Deltagarnas synlighet",
      "publicDescriptionSociety": "Beskrivning för medlemmar",
      "publicUrlSociety": "Evenemangslänk",
      "cartWishEnabled": "Visa golfbilsval för deltagare",
      "cartWishInfoText": "Tilläggsinformation om golfbilsönskemål"
    },
    "placeholders": {
      "name": "Ange tävlingsnamn",
      "description": "Valfri beskrivning av tävlingen...",
      "maxParticipants": "t.ex. 144",
      "new_competition": "Ny tävling",
      "searchClubs": "Sök klubb...",
      "selectType": "Välj typ...",
      "noTenant": "Ingen kund",
      "cartWishInfoText": "T.ex. endast med läkarintyg"
    },
    "switches": {
      "publicLabel": "Gör tävlingen offentlig",
      "participationLabel": "Aktivera deltagarregistrering",
      "allowTeeSelectionLabel": "Spelaren kan välja tee",
      "cancellationLabel": "Avbokning tillåten",
      "allowAbnormalTeesLabel": "Tillåt avvikande tees",
      "subCompetitionLabel": "Lägg till lagtävling",
      "liveScoringEnabledLabel": "Livescoring aktiverat",
      "publicLabelSociety": "Visa för medlemmar"
    },
    "hints": {
      "descriptionCounter": "/5000 tecken",
      "maxScoresPerPlayer": "Hur många resultat en spelare kan lämna in",
      "countingScores": "Hur många bästa resultat som räknas",
      "allowTeeSelection": "Om avstängd spelar spelaren från seriens tee baserat på kön",
      "allowTeeSelectionRoundInfo": "Denna inställning definieras på tävlingsnivå. Redigera tävlingens inställningar för att ändra detta.",
      "publicDescriptionHint": "Visas i den offentliga evenemangskalendern",
      "publicUrlCopy": "Kopiera länk",
      "publicUrlOpen": "Öppna i ny flik",
      "allowAbnormalTees": "Om aktiverat kan administratören definiera ett avvikande tee för en deltagare",
      "liveScoringHiddenHolesHelp": "Dolda hål blir synliga när resultaten publiceras",
      "publicDescriptionHintSociety": "Visas för medlemmar"
    },
    "placeholders_tab": {
      "seriesTitle": "Seriehantering",
      "seriesDescription": "Seriekonfiguration kommer att finnas tillgänglig här.",
      "participantsTitle": "Deltagarhantering",
      "participantsDescription": "Deltagarregistrering och hantering kommer att finnas tillgänglig här.",
      "roundsTitle": "Hantering av rundor",
      "roundsDescription": "Rundornas definition blir tillgänglig här."
    },
    "actions": {
      "cancel": "Avbryt",
      "create": "Skapa tävling",
      "update": "Uppdatera tävling",
      "delete": "Radera tävling",
      "save": "Spara tävling",
      "saving": "Sparar..."
    },
    "messages": {
      "unsavedChanges": "Du har osparade ändringar. Glöm inte att spara ditt arbete!",
      "unsaved_cancel_confirm": "Är du säker på att du vill avbryta? Alla osparade ändringar kommer att gå förlorade."
    },
    "errors": {
      "not_found": "Tävlingen hittades inte",
      "no_permission_edit": "Du har inte behörighet att redigera denna tävling",
      "no_permission_delete": "Du har inte behörighet att radera denna tävling",
      "failed_to_load": "Misslyckades att ladda tävlingsdetaljer",
      "failed_to_update": "Misslyckades att uppdatera tävlingen. Försök igen.",
      "failed_to_delete": "Misslyckades att radera tävlingen. Försök igen.",
      "invalid_data": "Ogiltig tävlingsdata",
      "duplicate_name_date": "En tävling med detta namn och datum existerar redan",
      "start_date_required": "Startdatum är obligatoriskt",
      "failed_to_create": "Skapandet av evenemanget misslyckades"
    },
    "success": {
      "updated": "Tävlingen \"{{name}}\" uppdaterades framgångsrikt!",
      "deleted": "Tävlingen \"{{name}}\" raderades framgångsrikt"
    },
    "delete_confirm": {
      "header": "Radera tävling",
      "body": "Är du säker på att du vill radera \"{{name}}\"?\n\nDenna åtgärd kan inte ångras och kommer permanent att ta bort denna tävling och all associerad data.",
      "button": "Radera tävling"
    },
    "edit": {
      "title": "Redigera tävling",
      "failed_to_load_title": "Misslyckades att ladda tävlingen",
      "back_button": "Tillbaka till tävlingar"
    },
    "participants": {
      "no_series_created": "Inga serier har skapats ännu. Skapa serier först för att hantera deltagare.",
      "select_series": "Välj serie för att hantera deltagare"
    },
    "name": "Namn",
    "name_placeholder": "Ange evenemangets namn",
    "start_date": "Startdatum",
    "participation_enabled": "Registrering tillåten",
    "is_public": "Offentlig",
    "restriction_options": {
      "ALL_PLAYERS": "För alla spelare",
      "EBIRDIE_MEMBERS": "Endast för Golfförbundets medlemmar",
      "HOME_CLUB_MEMBERS": "Endast för hemmaklubbens spelare",
      "SELECTED_CLUBS": "För valda klubbar"
    },
    "copy": {
      "title": "Kopiera evenemang",
      "description": "Skapa ett nytt evenemang genom att kopiera det nuvarande. Alla serier, rundor och inställningar kopieras. Deltagare och resultat kopieras inte.",
      "button": "Kopiera",
      "success": "Evenemanget \"{{name}}\" kopierades!",
      "failed": "Kopiering av evenemanget misslyckades"
    },
    "createCompetition": "Skapa evenemang",
    "cannot_delete_has_participants": "Tävlingen kan inte tas bort eftersom den har {{count}} bekräftade deltagare. Ta bort deltagarna först.",
    "matchplayTeamSizeTitle": "Match — antal spelare",
    "matchplayTeamSizeHelp": "Välj hur många spelare som ingår i ett lag.",
    "matchplayTeamSizeLabel": "Spelare per lag",
    "matchplayTeamSizeHint": "1 = individuell tävling, 2 = partävling (t.ex. Foursome, Greensome), 3–4 = lag (Scramble).",
    "matchplayTeamSizeBack": "Tillbaka",
    "matchplayTeamSizeContinue": "Fortsätt",
    "matchplayTeamSizeOptionTitle": {
      "1": "Individuell tävling",
      "2": "Partävling",
      "3": "Lag med 3 spelare",
      "4": "Lag med 4 spelare"
    },
    "matchplayTeamSizeOptionTag": {
      "1": "Matchspel · Poängbogey · Slagspel",
      "2": "Foursome · Greensome · Scramble",
      "3": "Scramble",
      "4": "Scramble"
    },
    "visibility_audience_options": {
      "EVERYONE": "För alla",
      "PARTICIPANTS": "Endast för deltagare",
      "HIDDEN": "Dold"
    },
    "visibility_audience_badge": {
      "EVERYONE": "Alla",
      "PARTICIPANTS": "Deltagare",
      "HIDDEN": "Dold"
    }
  },
  "series": {
    "title": "Serier",
    "add_series": "Lägg till serie",
    "edit_series": "Redigera serie",
    "create_series": "Skapa serie",
    "delete_series": "Radera serie",
    "select_series_to_edit": "Välj en serie att redigera",
    "no_series": "Inga serier",
    "no_series_message": "Inga serier har skapats för detta evenemang ännu.",
    "failed_to_load_series": "Misslyckades att ladda serier",
    "series_created_successfully": "Serien skapades framgångsrikt",
    "series_updated_successfully": "Serien uppdaterades framgångsrikt",
    "series_deleted_successfully": "Serien raderades framgångsrikt",
    "save_failed": "Misslyckades att spara serien",
    "delete_failed": "Misslyckades att radera serien",
    "new_series": "Ny serie",
    "series_details": "Serieuppgifter",
    "confirm_delete_series": "Är du säker på att du vill radera denna serie?",
    "form": {
      "name": "Seriens namn",
      "name_placeholder": "t.ex. Herrar A-serie",
      "gender": "Kön",
      "gender_help": "Välj kön som kan delta i denna serie",
      "age_min": "Minimiålder",
      "age_max": "Maximiålder",
      "age_range": "Åldersbegränsning",
      "hcp_min": "Minimumhandikapp",
      "hcp_max": "Maximumhandikapp",
      "hcp_range": "Handikappbegränsning",
      "max_participants": "Maximalt antal deltagare",
      "min_team_size": "Minsta lagstorlek",
      "max_team_size": "Största lagstorlek",
      "men_max_handicap": "Herrars maxhandikapp (SAT)",
      "women_max_handicap": "Damers maxhandikapp (SAT)",
      "handicap_factor": "Handikapfaktor",
      "basic_info_title": "Grundinformation",
      "handicap_settings_title": "Handikapinställningar",
      "team_handicap_percentages": "Lagets handikapprocent",
      "team_handicap_percentages_help": "Procentsatserna fördelas enligt handikapp, lägsta först",
      "player_percentage": "Spelare {{number}}",
      "cut_after_round": "CUT efter runda",
      "cut_line": "CUT vidare går",
      "result_type": "Primär resultattyp",
      "allow_waitlist": "Tillåt reservlista",
      "payment_mode": {
        "label": "Onlinebetalning",
        "not_in_use": "Inte i bruk",
        "compulsory": "Obligatorisk",
        "voluntary": "Frivillig",
        "not_available": "Betalningsalternativ är inte tillgängliga.",
        "not_available_contact": "Kontakta administratören."
      },
      "team_size": "Lagstorlek",
      "team_size_max": "Spelare i laget (max)",
      "team_size_min": "Spelare i laget (min)",
      "allow_incomplete_teams": "Tillåt ofullständiga lag",
      "draw_decision": "Lika resultat-avgörande",
      "secondary_result_type": "Sekundär resultattyp",
      "secondary_draw_decision": "Lika resultat-avgörande",
      "no_secondary": "Ingen sekundär"
    },
    "display": {
      "age_range": "Ålder: {{range}}",
      "hcp_range": "HCP: {{range}}",
      "max_participants": "Max: {{count}}",
      "current_participants": "{{current}}/{{max}} deltagare",
      "participants_count": "{{count}} deltagare",
      "full": "Full",
      "all_genders": "Alla",
      "no_constraints": "Inga begränsningar"
    },
    "cannot_delete_has_participants": "Serien kan inte tas bort eftersom den har {{count}} bekräftade deltagare. Ta bort deltagarna först.",
    "drawDecisions": {
      "SHARED_POSITION": "Delad placering",
      "MATHEMATICAL": "Matematisk",
      "SLOPE_HANDICAP": "Slope-handikapp",
      "EXACT_HANDICAP": "Exakt handikapp"
    },
    "match_play_description": "Definiera och hantera matchspel för denna serie. Skapa schema, ange matchningar och registrera matchresultat.",
    "configure_match_play": "Konfigurera schema och matcher",
    "tabs": {
      "general": "Allmänt",
      "tees": "Tees"
    },
    "tees": {
      "title": "Seriens tee-inställningar",
      "empty_no_rounds": "Skapa minst en runda först",
      "empty_no_rounds_help": "Seriespecifika tees kräver rundens bana och teeplatser.",
      "go_to_rounds": "Gå till rundor",
      "column": {
        "mens_override": "Herrnas tee",
        "womens_override": "Damernas tee"
      },
      "use_round_default": "Använd rundens standard",
      "save": "Spara tee-inställningar",
      "saved_success": "Seriens tee-inställningar sparade",
      "save_failed": "Det gick inte att spara tee-inställningarna",
      "row": {
        "round_label": "RUNDA",
        "default_suffix": "(standard)"
      }
    }
  },
  "rounds": {
    "title": "Rundor",
    "add_round": "Lägg till runda",
    "edit_round": "Redigera runda",
    "create_round": "Skapa runda",
    "delete_round": "Ta bort runda",
    "no_rounds": "Inga rundor",
    "no_rounds_message": "Inga rundor har skapats för denna tävling än.",
    "loading_rounds": "Laddar rundor...",
    "failed_to_load_rounds": "Kunde inte ladda rundor",
    "round_created_successfully": "Runda skapad framgångsrikt",
    "round_updated_successfully": "Runda uppdaterad framgångsrikt",
    "round_deleted_successfully": "Runda borttagen framgångsrikt",
    "failed_to_save_round": "Kunde inte spara runda",
    "failed_to_delete_round": "Kunde inte ta bort runda",
    "confirm_delete_round": "Är du säker på att du vill ta bort denna runda?",
    "new_round": "Ny runda",
    "round_details": "Rundauppgifter",
    "no_courses": "Inga banor konfigurerade",
    "form": {
      "date": "Rundans datum",
      "play_type": "Spelform",
      "courses": "Banor",
      "course": "Bana",
      "add_course": "Lägg till bana",
      "remove_course": "Ta bort bana",
      "select_course": "Välj bana",
      "select_course_placeholder": "Välj en bana...",
      "course_color": "Banfärg",
      "course_color_placeholder": "t.ex. Röd, Blå, Gul",
      "start_hole": "Starthål",
      "end_hole": "Sluthål",
      "default_mens_tee": "Standard herrteesats",
      "default_womens_tee": "Standard damteesats",
      "select_tee": "Välj teesats...",
      "starting_arrangement": "Startarrangemang",
      "missing-course": "Rundan måste ha minst en bana definierad",
      "counting_scores_per_team": "Resultat per lag",
      "time_schedule_template": "Tidsschemamall",
      "no_time_template": "Ingen tidsschemamall",
      "no_templates_for_course": "För denna bana finns inga schemamallar definierade.",
      "handicap_settings_title": "Handikapinställningar",
      "men_max_handicap": "Herrars maxhandikapp (SAT)",
      "women_max_handicap": "Damers maxhandikapp (SAT)",
      "handicap_factor": "Handikapfaktor",
      "team_handicap_percentages": "Lagets handikapsprocent",
      "player_percentage": "Spelare {{number}}",
      "affects_handicaps": "Påverkar handikapp",
      "automatically_send_scores": "Skicka resultat automatiskt",
      "ebirdie_settings_title": "eBirdie-inställningar",
      "select_play_type_placeholder": "Välj spelform...",
      "hints": {
        "maxHandicap": "MGA (Maximalt Givet Handikapp) begränsar handikappet innan slope-handikappet beräknas. T.ex. om spelarens handikapp är 42.0 och MGA = 36.0, används handikappet 36.0 i beräkningen. Tom = ingen begränsning.",
        "handicapFactor": "Slope-handikappet multipliceras med handikappfaktorn INNAN avrundning.",
        "teamHandicapPercentages": "Procenten fördelas enligt handikapp, lägst handikapp först. T.ex. Greensome: 60% / 40%. Varje spelares personliga slope-handikapp multipliceras med koefficienten, varefter handikappen summeras INNAN avrundning",
        "mensTeeRequired": "Serierna har manliga spelare — standard herrtee krävs för slope-beräkning vid lottning.",
        "womensTeeRequired": "Serierna har kvinnliga spelare — standard damtee krävs för slope-beräkning vid lottning.",
        "affects_handicaps": "När aktiverad är rundens resultat berättigade till eBirdie-handikapprapportering",
        "automatically_send_scores": "Handikapp skickas automatiskt kl. {{time}}",
        "automatically_send_scores_disabled": "Aktivera 'Påverkar handikapp' för att använda automatisk sändning",
        "limitTeamHandicapToMinSlope": "När aktiverat kan lagets beräknade handikapp inte vara högre än lagets bästa spelares slope-handikapp. Handikappet begränsas till den enskilda spelarens lägsta slope-handikapp."
      },
      "round_basics_title": "Rundans uppgifter",
      "course_card_title": "Bana {{number}}",
      "schedule_section_title": "Målschema",
      "limit_team_handicap_to_min_slope": "Begränsa lagets handikapp till det lägsta individuella handikappet",
      "course_library_group": "Mina banor",
      "course_catalog_group": "Alla banor",
      "course_search_placeholder": "Sök bana...",
      "course_import_failed": "Det gick inte att lägga till banan",
      "course_unavailable": "Banan är inte längre tillgänglig"
    },
    "course_config": {
      "start_time": "Starttid",
      "start_interval": "Startintervall (minuter)",
      "players_in_flight": "Spelare i flight",
      "teams_in_flight": "Lag i flight"
    },
    "starting_arrangements": {
      "one_tee": "En tee",
      "two_tees": "Två tees",
      "shotgun": "Shotgun"
    },
    "display": {
      "default_tees": "Herrar: {{menTee}}, Damer: {{womenTee}}",
      "multi_course": "{{count}} banor"
    },
    "cannot_delete_has_results": "Rundan kan inte tas bort eftersom resultat har registrerats för den."
  },
  "registration": {
    "register_for_series": "Anmäl dig till serie",
    "first_name": "Förnamn",
    "last_name": "Efternamn",
    "email": "E-post",
    "phone": "Telefonnummer",
    "gender": "Kön",
    "gender_male": "Man",
    "gender_female": "Kvinna",
    "gender_other": "Annat",
    "birth_year": "Födelseår",
    "handicap_index": "Handicap",
    "tee_set": "Tee",
    "preferred_start_time": "Önskad starttid",
    "no_preference": "Ingen preferens",
    "morning": "Morgon",
    "afternoon": "Eftermiddag",
    "evening": "Kväll",
    "notes": "Anteckningar",
    "notes_placeholder": "Särskilda önskemål eller information...",
    "register": "Anmäl",
    "registering": "Anmäler...",
    "registration_confirmed": "Anmälan bekräftad!",
    "added_to_waitlist": "Tillagd på väntelista",
    "registration_failed": "Anmälan misslyckades",
    "registration_full_waitlist": "Serien är full. Du kommer att läggas till på väntelistan.",
    "team_size_info": "Detta är en lagtävling. Lag måste ha {{min}}-{{max}} spelare. Stöd för flera spelare kommer snart.",
    "team_name": "Lagnamn",
    "team_name_placeholder": "Ange lagnamn...",
    "team_size_requirement": "Laget måste ha {{min}}-{{max}} spelare",
    "player_number": "Spelare {{number}}",
    "participant_info": "Deltagarinformation",
    "add_player": "Lägg till spelare",
    "errors": {
      "first_name_required": "Förnamn krävs",
      "last_name_required": "Efternamn krävs",
      "email_required": "E-post krävs",
      "email_invalid": "Ogiltig e-postadress",
      "phone_required": "Telefonnummer krävs",
      "gender_required": "Kön krävs",
      "birth_year_required": "Födelseår krävs",
      "handicap_required": "Handicap krävs",
      "handicap_invalid": "Handicap måste vara mellan -10.0 och 54.0",
      "tee_set_required": "Val av tee krävs",
      "min_participants": "Laget måste ha minst {{min}} spelare",
      "max_participants": "Laget kan ha högst {{max}} spelare",
      "unsaved_participants": "Spara alla spelare innan du skickar registreringen",
      "series_required": "Serie krävs",
      "terms_required": "Godkänn villkoren för att fortsätta",
      "generic": "Registreringen misslyckades. Försök igen."
    },
    "status": {
      "confirmed": "Bekräftad",
      "waitlisted": "Väntelista",
      "withdrawn": "Återkallad"
    },
    "gender_not_specified": "Ej specificerad",
    "start_time_preference": "Starttidsönskemål",
    "start_time_preference_none": "Inget önskemål",
    "start_time_preference_early": "Tidig",
    "start_time_preference_late": "Sen",
    "accept_terms": "Jag godkänner registreringsvillkoren"
  },
  "my_participations": {
    "title": "Mina anmälningar",
    "no_participations": "Du har inte anmält dig till några tävlingar än.",
    "browse_competitions": "Bläddra bland tävlingar",
    "failed_to_load": "Kunde inte ladda anmälningar",
    "registered_at": "Anmäld",
    "waitlist_position": "Väntelisteposition",
    "view_competition": "Visa",
    "withdraw": "Återkalla",
    "withdrawal_successful": "Återkallelsen lyckades",
    "withdrawal_failed": "Återkallelsen misslyckades",
    "withdraw_confirmation_title": "Återkalla anmälan",
    "withdraw_confirmation_message": "Är du säker på att du vill återkalla din anmälan?"
  },
  "admin": {
    "capacity_exceeded": "Kapacitet överskriden",
    "capacity_warning_competition": "Tävlingen är full ({{current}}/{{max}} bekräftade)",
    "capacity_warning_series": "Serien \"{{seriesName}}\" är full ({{current}}/{{max}} bekräftade)",
    "admin_capacity_choice_prompt": "Vill du lägga till deltagaren på väntelistan eller bekräfta deltagande genom att kringgå kapacitetsgränsen?",
    "add_to_waitlist": "Lägg till på väntelista",
    "add_as_confirmed_bypass": "Bekräfta (kringgå gräns)",
    "participation_management": "Hantering av deltagare",
    "confirmed": "Bekräftad",
    "waitlisted": "Reservlista",
    "withdrawn": "Avbruten",
    "disqualified": "Diskvalificerad",
    "status_confirmed": "Deltagare",
    "status_waitlisted": "På reservlista",
    "status_withdrawn": "Avbruten",
    "status_pending": "Väntar på betalning",
    "search_by_name": "Sök efter namn...",
    "participant": "Deltagare",
    "email": "E-post",
    "handicap": "Handikapp",
    "status": "Status",
    "registered_at": "Registrerad",
    "actions": "Åtgärder",
    "no_participations": "Inga deltagare",
    "confirm": "Bekräfta",
    "confirm_participation_message": "Vill du verkligen bekräfta detta deltagande?",
    "move_to_waitlist": "Flytta till reservlista",
    "refresh_data": "Uppdatera uppgifter",
    "disqualify": "Diskvalificera",
    "refresh_all": "Uppdatera alla",
    "participation_confirmed": "Deltagande bekräftat",
    "moved_to_waitlist": "Flyttad till reservlista",
    "participant_refreshed": "Deltagarens uppgifter uppdaterade",
    "all_participants_refreshed": "Alla deltagare uppdaterade",
    "participant_disqualified": "Deltagare diskvalificerad",
    "confirm_failed": "Bekräftelse misslyckades",
    "move_to_waitlist_failed": "Flytt till reservlista misslyckades",
    "refresh_failed": "Uppdatering av uppgifter misslyckades",
    "refresh_all_failed": "Uppdatering av alla misslyckades",
    "disqualify_failed": "Diskvalificering misslyckades",
    "disqualification_reason_prompt": "Ange orsak för diskvalificering:",
    "series": "Serie",
    "add_participation": "Lägg till deltagare",
    "batch_actions": "Åtgärder",
    "batch_actions_disabled": "Välj deltagare först",
    "batch_withdraw": "Ta bort deltaganden",
    "batch_confirm": "Flytta till deltagare",
    "batch_move_to_waitlist": "Flytta till reservlista",
    "batch_withdraw_confirm_title": "Ta bort valda deltaganden",
    "batch_withdraw_confirm_body": "Vill du verkligen ta bort {{count}} deltaganden?",
    "participations_withdrawn": "{{count}} deltaganden borttagna",
    "participations_confirmed": "{{count}} deltaganden bekräftade",
    "participations_moved_to_waitlist": "{{count}} deltaganden flyttade till reservlista",
    "batch_withdraw_failed": "Borttagning av deltaganden misslyckades",
    "batch_confirm_failed": "Bekräftelse av deltaganden misslyckades",
    "batch_move_to_waitlist_failed": "Flytt till reservlista misslyckades",
    "edit_participation": "Redigera deltagare",
    "add_team": "Lägg till lag",
    "no_eligible_series": "Deltagaren är inte behörig till någon serie baserat på kön, ålder eller handikapp.",
    "no_series_to_register": "Inga serier tillgängliga. Skapa serier först.",
    "confirm_move_to_waitlist": "Vill du verkligen flytta deltagaren till reservlistan?",
    "withdraw": "Avbryt deltagande",
    "confirm_withdraw_participation": "Vill du verkligen avbryta detta deltagande?",
    "participation_withdrawn": "Deltagande avbrutet",
    "withdraw_failed": "Avbrytande av deltagande misslyckades",
    "remove_from_team": "Ta bort från laget",
    "confirm_remove_from_team": "Vill du verkligen ta bort spelaren {{name}} från laget?",
    "remove_from_team_failed": "Borttagning av spelare från laget misslyckades",
    "participant_removed": "Spelare borttagen från laget",
    "edit_participation_info": "Du kan byta deltagarens serie här.",
    "participation_updated": "Deltagande uppdaterat",
    "participation_created": "Deltagande tillagt",
    "update_failed": "Uppdatering misslyckades",
    "result_status_in_progress": "Pågående",
    "result_status_completed": "Klar",
    "result_status_abandoned": "Avbruten",
    "result_status_disqualified": "Diskvalificerad",
    "result_status_withdrawn": "Avbruten",
    "holes_played": "{{count}}/{{total}} hål",
    "mark_as_paid": "Markera som betald",
    "paid": "Betald",
    "select_fee": "Välj avgift",
    "marked_as_paid": "{{count}} deltaganden markerade som betalda",
    "mark_as_paid_failed": "Markering som betald misslyckades",
    "failed_to_load_fees": "Laddning av avgifter misslyckades",
    "no_fees_configured": "Inga avgifter definierade",
    "multiple_series_selected": "Deltagare från flera serier valda",
    "select_price": "Välj pris",
    "fetch_from_profile": "Hämta från profil",
    "fetch_handicap_from_ebirdie": "Hämta handikapuppgifter",
    "handicap_factor_help": "Lämna tomt för att använda rondens allmänna handikapfaktor. Detta åsidosätter rondinställningarna för denna spelare.",
    "handicap_factor_warning": "Handikapfaktor {{factor}}% i bruk",
    "no_user_linked": "Ingen användarprofil länkad till deltagaren",
    "handicap_updated": "Handikapuppgifter uppdaterade",
    "no_handicap_in_profile": "Användarprofilen har inget handikapp",
    "failed_to_fetch_handicap": "Hämtning av handikapp misslyckades",
    "fetch_all_handicaps": "Uppdatera handikappuppgifter",
    "no_linked_users": "Inga deltagare är länkade till användarprofiler",
    "handicaps_updated": "Handikapp uppdaterade",
    "some_handicaps_failed": "Hämtning av {{count}} handikapp misslyckades",
    "failed_to_fetch_handicaps": "Hämtning av handikapp misslyckades",
    "add_multiple_participations": "Lägg till flera",
    "add_players": "Lägg till spelare",
    "all_players_need_series": "Alla spelare måste ha en serie vald",
    "batch_save_success": "Sparat",
    "multiple_series_match": "Flera lämpliga serier hittades för spelaren",
    "participants_count": "Deltagare",
    "edit_team": "Redigera lag",
    "add_player_to_team": "Lägg till spelare i laget",
    "save_failed": "Sparning misslyckades",
    "add_player": "Lägg till",
    "add_multiple_players": "Lägg till flera",
    "back_to_competitions": "Tillbaka till tävlingar",
    "series_full_title": "Serien är full",
    "series_full_message": "Antalet deltagare i serien är fullt ({{currentCount}}/{{maxParticipants}}). Är du säker på att du vill lägga till {{type}}?",
    "competition_full_title": "Tävlingen är full",
    "competition_full_message": "Antalet deltagare i tävlingen är fullt ({{currentCount}}/{{maxParticipants}}). Är du säker på att du vill lägga till {{type}}?",
    "series_full_type_player": "spelaren",
    "series_full_type_players": "spelarna",
    "series_full_type_team": "laget",
    "add_as_confirmed_player": "Lägg till spelare",
    "add_as_confirmed_players": "Lägg till spelare",
    "add_as_confirmed_team": "Lägg till lag",
    "registered_by": "Registrerad av",
    "registration_time": "Registreringstid",
    "incompatible_series": "Inkompatibla serier",
    "mark_as_paid_member_paid": "Betald",
    "select_members_to_mark_paid": "Välj medlemmar som markeras som betalda",
    "waitlisted_divider": "På reservlista",
    "paid_via_paytrail": "Betald via nätbetalning",
    "filter_active": "Deltagare",
    "filter_cancelled": "Avbokat",
    "filter_unpaid": "Obetalda",
    "selected_tee_label": "Avvikande tee",
    "selected_tee_help": "Lämna tomt för att använda seriens standard-tee baserat på kön. Avvikande tee påverkar beräkningen av slope-handikapp.",
    "abnormal_tee_indicator": "Avvikande tee: {{teeName}}",
    "batch_send_email": "Skicka e-post",
    "send_email_modal_title": "Skicka e-post till deltagare",
    "send_email_subject_label": "Ämne",
    "send_email_subject_placeholder": "T.ex. Väderuppdatering för lördagens runda",
    "send_email_body_label": "Meddelande",
    "send_email_body_placeholder": "Skriv ditt meddelande...",
    "send_email_subject_required": "Ämne är obligatoriskt",
    "send_email_body_required": "Meddelande är obligatoriskt",
    "send_email_send": "Skicka",
    "send_email_cancel": "Avbryt",
    "send_email_sending": "Skickar...",
    "send_email_success": "E-post skickad",
    "send_email_failed": "Sändning av e-post misslyckades",
    "sendEmailSwitch": {
      "label": "Skicka e-post",
      "batchLabel": "Skicka e-post till alla deltagare"
    },
    "confirmStatusChange": {
      "title": "Bekräfta statusändring",
      "body": "Bekräftar {{count}} deltaganden.",
      "confirm": "Bekräfta",
      "cancel": "Avbryt"
    },
    "ranking_eligible_on": "Påverkar rankingresultat",
    "ranking_eligible_off": "Påverkar inte rankingresultat",
    "batch_copy_emails": "Kopiera e-postadresser",
    "batch_export_emails_csv": "Ladda ner e-postlista (CSV)",
    "copy_emails_success": "{{count}} e-postadresser kopierade till urklipp",
    "copy_emails_failed": "Kopiering av e-postadresser misslyckades",
    "export_emails_csv_failed": "Skapandet av CSV-filen misslyckades",
    "refresh_handicaps_confirm": {
      "title": "Bekräfta uppdatering av handikapp",
      "update_result_playing_handicap": "Uppdatera spelhandikapp i resultaten",
      "ebirdie_submitted_warning": "Resultatet har redan skickats till eBirdie och spelhandikappet kan inte längre uppdateras.",
      "skipped_due_to_ebirdie": "En del spelhandikappuppdateringar hoppades över eftersom resultaten redan har skickats till eBirdie.",
      "batch_intro": "Uppdatera spelhandikapp i följande spelares resultat:",
      "select_all": "Välj alla",
      "ebirdie_row_label": "{{name}} (eBirdie)",
      "players_have_saved_results_one": "En spelare har redan ett sparat resultat i den här tävlingen.",
      "players_have_saved_results_other": "Spelare har redan sparade resultat i den här tävlingen.",
      "batch_explanation": "Dessa spelare har redan ett sparat resultat i denna tävling."
    },
    "fee_modal": {
      "compulsory_alert": "Den här serien har en obligatorisk deltagaravgift. Du kan markera den som betald nu, eller så kan spelaren betala den via nätbetalning när rundan startar.",
      "voluntary_alert": "Den här serien har en frivillig deltagaravgift. Du kan markera den som betald nu, eller så kan spelaren betala den via nätbetalning när rundan startar.",
      "continue_without_payment": "Fortsätt utan betalning"
    },
    "filter_button": "Filtrera",
    "filter_panel_title": "Filtrera deltagare",
    "filter_group_status": "Status",
    "filter_group_series": "Serie",
    "filter_group_club": "Klubb",
    "filter_group_gender": "Kön",
    "filter_apply": "Visa resultat ({{count}})",
    "cart_wish_on": "Vill ha golfbil",
    "cart_wish_off": "Vill inte ha golfbil",
    "cart_wish_column": "Golfbil"
  },
  "upcoming_competitions": "Kommande tävlingar",
  "competition_round": "Tävlingsrunda",
  "upload_image": "Ladda upp bild",
  "upload_invitation": "Ladda upp inbjudan",
  "change_image": "Byt bild",
  "change_invitation": "Byt inbjudan",
  "remove_image": "Ta bort bild",
  "remove_invitation": "Ta bort inbjudan",
  "image_uploaded": "Bild uppladdad",
  "invitation_uploaded": "Inbjudan uppladdad",
  "image_removed": "Bild borttagen",
  "invitation_removed": "Inbjudan borttagen",
  "failed_to_upload_image": "Uppladdning av bild misslyckades",
  "failed_to_upload_invitation": "Uppladdning av inbjudan misslyckades",
  "failed_to_remove_image": "Borttagning av bild misslyckades",
  "failed_to_remove_invitation": "Borttagning av inbjudan misslyckades",
  "invalid_file_type": "Ogiltig filtyp",
  "invalid_invitation_type": "Ogiltig filtyp. Tillåtna: PDF, JPEG, PNG, WebP",
  "file_too_large": "Filen är för stor",
  "uploading": "Laddar upp...",
  "removing": "Tar bort...",
  "view_button": "Visa",
  "view_invitation": "Visa inbjudan",
  "invitation_formats": "PDF, JPEG, PNG, WebP",
  "weekly_competitions_available": "Veckotävlingar",
  "select_competitions_to_participate": "Välj veckovis tävling som du vill delta i under denna runda",
  "submitted_scores": "Inlämnade resultat",
  "counting_scores": "Räknande resultat",
  "eligible_series": "Godkända serier",
  "failed_to_load_weekly_competitions": "Misslyckades att ladda veckotävlingar",
  "tee_selection_disabled_by_competition": "Tee bestäms enligt tävlingens serieinställningar",
  "fees": {
    "title": "Deltagaravgift",
    "compulsory_description": "Deltagaravgiften är obligatorisk. Betalning sker i samband med anmälan.",
    "voluntary_description": "Deltagaravgiften är frivillig. Du kan betala i samband med anmälan eller senare."
  },
  "playTypes": {
    "SINGLE": "Individuell",
    "STROKE_PLAY": "Slagspel",
    "STABLEFORD": "Stableford",
    "PAR_BOGEY": "Par/Bogey",
    "MATCH_PLAY": "Matchspel",
    "GREENSOME": "Greensome",
    "FOURSOME": "Foursome",
    "SCRAMBLE": "Scramble",
    "BEST_BALL": "Best Ball",
    "FOUR_BALL": "Four Ball (2 spelare)",
    "IRISH_RUMBLE": "Irish Rumble",
    "MATCH": "Lagmatch (Ryder Cup-stil)",
    "BRACKET": "Schema (matchspel)",
    "LEAGUE": "Liga"
  },
  "filters": {
    "all_clubs": "Alla klubbar",
    "no_tenant": "Ingen klubb"
  },
  "competition_info": {
    "basic_info_title": "Grundinformation",
    "registration_settings_title": "Anmälningsinställningar",
    "media_title": "Visuell profil och bilagor"
  },
  "series_fees": {
    "payment_settings_title": "Priser och betalning",
    "title": "Priser",
    "name": "Beskrivning",
    "amount": "Belopp",
    "add_fee": "+ Lägg till pris",
    "saved": "Avgifter sparade",
    "no_fees": "Inga avgifter",
    "name_placeholder": "T.ex. Deltagaravgift",
    "created": "Avgift tillagd",
    "updated": "Avgift uppdaterad",
    "deleted": "Avgift borttagen",
    "load_failed": "Laddning av avgifter misslyckades",
    "save_failed": "Sparande av avgift misslyckades",
    "delete_failed": "Borttagning av avgift misslyckades",
    "invalid_amount": "Ogiltigt belopp",
    "delete_title": "Ta bort avgift",
    "confirm_delete": "Är du säker på att du vill ta bort denna avgift?",
    "no_fees_info": "Inga priser har definierats för serien.",
    "add_fee_link": "Lägg till pris."
  },
  "flights": {
    "title": "Starter",
    "delete_flights": "Ta bort starter",
    "confirm_delete_flights": "Är du säker på att du vill ta bort valda starter? Denna åtgärd kan inte ångras.",
    "deleted_successfully": "Starter borttagna",
    "delete_failed": "Borttagning av starter misslyckades",
    "edit_entry_title": "Redigera start",
    "select_participant": "Välj deltagare",
    "no_flights": "Inga starter",
    "add_participant": "Lägg till",
    "flight_lottery": "Lottning",
    "run_lottery": "Genomför lottning",
    "lottery_confirm_title": "Genomför startlottning",
    "lottery_confirm_body": "Detta tar bort alla nuvarande starter och skapar nya med slumpmässig fördelning av deltagare. Vill du fortsätta?",
    "lottery_success": "Lottning genomförd. {{count}} starter skapades.",
    "lottery_failed": "Genomförande av lottning misslyckades",
    "lottery_mode": "Lottningssätt",
    "lottery_mode_random": "Slumpmässigt",
    "lottery_mode_registration_order": "Anmälningsordning",
    "lottery_mode_random_description": "Deltagare lottas i slumpmässig ordning",
    "lottery_mode_registration_order_description": "Deltagare ordnas enligt anmälningsordning",
    "lottery_mode_results_reversed": "Omvänd resultatordning",
    "lottery_mode_results_reversed_description": "Spelare ordnas efter tidigare rundors resultat - sämsta resultat först",
    "lottery_by_series": "Lottning per serie",
    "lottery_by_series_description": "Varje serie lottas separat till egna starter",
    "lottery_by_series_disabled_single": "Tävlingen har bara en serie",
    "preserve_existing_order": "Behåll nuvarande ordning",
    "preserve_existing_order_description": "Nya starter läggs till efter befintliga",
    "respect_start_time_preferences": "Ta hänsyn till starttidsönskemål",
    "respect_start_time_preferences_description": "De som vill ha tidig tid placeras i början, sena i slutet",
    "respect_start_time_preferences_note": "Starttidsönskemål beaktas inte i anmälningsordning",
    "reorder_success": "Startordningen uppdaterad",
    "reorder_failed": "Uppdatering av startordningen misslyckades",
    "entry_moved": "Deltagare flyttad",
    "move_failed": "Flytt misslyckades",
    "edit_flight": "Redigera start",
    "no_entries": "Inga spelare i starten",
    "empty_slot": "Tom plats",
    "unknown_participant": "Okänd deltagare",
    "entry_removed": "Spelare borttagen från start",
    "remove_entry_failed": "Borttagning av spelare misslyckades",
    "flight_updated": "Start uppdaterad",
    "update_failed": "Uppdatering av start misslyckades",
    "unsaved_changes_warning": "Du har osparade ändringar. Vill du fortsätta?",
    "pdf_columns": "Välj kolumner",
    "export_pdf": "Ladda ned PDF",
    "publish_flights": "Publicera starter",
    "flights_published": "Starter publicerade",
    "flights_unpublished": "Starter dolda",
    "publish_toggle_failed": "Ändring av publicering misslyckades",
    "flights_not_published": "Starter har inte publicerats.",
    "publish_flights_link": "Publicera.",
    "cut_was_needed_alert": "Gallring för föregående runda har inte utförts:",
    "check_cut_status": "Gå till att utföra gallring för serien {{seriesName}}",
    "no_participants": "Inga spelare",
    "cannot_delete_has_results": "Starter med sparade resultat kan inte tas bort. Ta bort resultaten först.",
    "publish_modal_title": "Publicera starter",
    "publish_modal_body": "Starterna är redo att publiceras.",
    "publish_modal_notify_checkbox": "Skicka starttidsavisering till alla bekräftade deltagare",
    "publish_modal_publish_button": "Publicera",
    "send_start_times_to_selected": "Skicka starttider till valda",
    "send_start_times_success": "Starttidsaviseringar skickade",
    "send_start_times_failed": "Sändning av starttidsaviseringar misslyckades",
    "start_time_sent": "Starttidsavisering skickad",
    "start_time_not_sent": "Starttidsavisering inte skickad",
    "send_start_time": "Skicka starttid via e-post",
    "resend_start_time": "Starttidsavisering skickad — skicka igen",
    "resend_start_time_title": "Skicka starttidsavisering",
    "resend_start_time_body": "Skicka starttidsavisering till spelaren <strong>{{name}}</strong> ({{email}})?",
    "start_time_no_email_address": "Spelaren har ingen e-postadress — avisering kan inte skickas",
    "add_flights_button": "Lägg till starter",
    "create_flights_modal_title": "Skapa tomma starter",
    "create_flights_count_label": "Antal starter",
    "create_flights_count_validation": "Ange ett positivt heltal",
    "create_flights_submit_button": "Skapa",
    "flights_created": "{{count}} starter skapades",
    "create_failed": "Det gick inte att skapa starter",
    "cannot_remove_entry_has_results": "En spelare med sparade resultat kan inte flyttas eller tas bort från starten. Ta bort resultaten först.",
    "publish_modal_audience_label": "Starttidernas synlighet",
    "audience_modal_title": "Ändra starttidernas synlighet",
    "audience_updated": "Synligheten uppdaterad"
  },
  "results": {
    "scorecards": "Resultatkort",
    "no_results": "Inga resultat",
    "edit_result_title": "Redigera resultat",
    "edit_placeholder": "Resultatredigering kommer snart...",
    "creating_result": "Skapar resultat...",
    "saving_result": "Sparar resultat...",
    "saving_all": "Sparar alla...",
    "deleting_result": "Tar bort resultat...",
    "delete_result": "Ta bort resultat",
    "delete_confirm": "Är du säker på att du vill ta bort detta resultat?",
    "result_saved": "Resultat sparat",
    "all_results_saved": "Alla resultat sparade",
    "some_saves_failed": "Sparande av {{count}} resultat misslyckades",
    "result_deleted": "Resultat borttaget",
    "save_failed": "Sparande misslyckades",
    "delete_failed": "Borttagning misslyckades",
    "save_current": "Spara",
    "save_all_close": "Spara alla och stäng",
    "unsaved_changes_warning": "Du har osparade ändringar. Vill du fortsätta?",
    "edit_flight": "Redigera startresultat",
    "edit_team_result": "Redigera lagresultat",
    "edit_player_result": "Redigera spelarresultat",
    "disqualified": "Diskvalificerad",
    "withdrawn": "Återdragen",
    "disqualification_reason": "Orsak till diskvalificering",
    "set_to_par_superuser": "Sätt till par (superanvändare)",
    "editing_scorecard": "Redigerar resultatkort",
    "saved_successfully": "Sparat",
    "does_not_affect_handicap": "Påverkar inte handikapp",
    "cut_needed_alert": "Gallring för denna runda har inte utförts:",
    "execute_cut": "Gå till att utföra gallring för serien {{seriesName}}",
    "hints": {
      "does_not_affect_handicap": "När aktiverad skickas inte detta resultatkorts resultat till eBirdie"
    },
    "scorecard_signed": "Resultatkort signerat",
    "publish_results": "Publicera resultat",
    "results_published": "Resultat publicerade",
    "results_unpublished": "Resultat dolda",
    "publish_toggle_failed": "Ändring av publicering misslyckades",
    "results_not_published": "Resultat har inte publicerats",
    "publish_modal_title": "Publicera resultat",
    "publish_modal_body": "Publicering gör resultaten synliga för deltagare och i den offentliga tävlingskalendern.",
    "publish_modal_notify_checkbox": "Skicka resultatmeddelande till alla spelare i rundan",
    "publish_modal_publish_button": "Publicera",
    "live": "Live",
    "refresh": "Uppdatera",
    "publish_modal_audience_label": "Resultatens synlighet",
    "audience_modal_title": "Ändra resultatens synlighet",
    "audience_updated": "Synligheten uppdaterad",
    "publish_modal_body_society": "Publicering gör resultaten synliga för medlemmar."
  },
  "scoring": {
    "select_series": "Välj serie",
    "no_series": "Inga serier",
    "no_rounds": "Inga rundor",
    "no_results": "Inga resultat tillgängliga",
    "error_loading_rankings": "Laddning av resultat misslyckades",
    "resultType": "Resultattyp",
    "resultTypes": {
      "strokeScratch": "Slagspel Scratch",
      "strokeHcp": "Slagspel HCP",
      "stablefordScratch": "Stableford Scratch",
      "stablefordHcp": "Stableford HCP",
      "maxScoreScratch": "Maxresultat Scratch",
      "maxScoreHcp": "Maxresultat HCP",
      "system36": "System 36"
    },
    "round": "Runda",
    "round_abbrev": "R",
    "cumulative": "Kumulativt",
    "hole_details": "Hålresultat",
    "rank": "Plats",
    "team": "Lag",
    "player": "Spelare",
    "players": "Spelare",
    "score": "Resultat",
    "total": "Totalt",
    "front9": "Ut",
    "back9": "In",
    "relative_to_par": "Par +/-",
    "cut_line": "CUT-gräns",
    "apply_cut": "Tillämpa CUT",
    "remove_cut": "Ta bort CUT",
    "cut_applied_success": "CUT tillämpad: {{count}} spelare utgångna",
    "cut_removed_success": "CUT borttagen: {{count}} spelare återställda",
    "cut_apply_error": "Tillämpning av CUT misslyckades",
    "cut_remove_error": "Borttagning av CUT misslyckades",
    "team_results": "Lagresultat",
    "individual_results": "Individuella resultat",
    "cumulative_results": "Sammanlagda resultat",
    "liveScoringLauncher": {
      "title": "Livescoring",
      "playersPerPage": "Spelare per sida",
      "pageRotation": "Sidbyte",
      "seconds": "sekunder",
      "off": "Av",
      "showHoleDetails": "Hålresultat",
      "previewUrl": "Förhandsgranska URL",
      "openLiveView": "Öppna",
      "cancel": "Avbryt",
      "matchesPerPage": "Matcher per sida",
      "rounds": "Visade rundor",
      "roundsHint": "Välj de rundor du vill visa. Lämna tomt för att visa alla.",
      "seriesToShow": "Serier och resultattyper att visa",
      "teamsPerPage": "Lag per sida",
      "autoFit": "Automatisk (anpassa till skärmen)"
    },
    "par": "Par",
    "cut_available_alert": "Gallring måste utföras:",
    "go_to_cut": "Gå till att utföra gallring för serien {{seriesName}}",
    "cut_warning_title": "Varning: olika resultattyp",
    "cut_warning_confirm": "Utför gallring",
    "cut_result_type_mismatch_warning": "Varning: nuvarande resultattyp motsvarar inte seriens primära resultattyp. Är du säker på att du vill utföra gallringen baserat på dessa resultat?\n\nNuvarande resultattyp: {{currentType}}\nSeriens primära resultattyp: {{defaultType}}\nSerie: {{seriesName}}",
    "no_valid_strokeplay_result": "Inget giltigt slagspelsresultat",
    "flight_scoring": {
      "tabs": {
        "results": "Resultat",
        "leaderboard": "Leaderboard"
      },
      "hole": "Hål",
      "last_modified_by": "Senast ändrad av",
      "finish_button": "Färdigställ resultat",
      "error_loading": "Det gick inte att ladda resultaten",
      "leaderboard_placeholder": "Leaderboard-vy kommer snart",
      "exit_confirm_header": "Vill du avsluta?",
      "exit_confirm_body": "Du kan fortsätta mata in resultat senare. Inmatade resultat försvinner inte.",
      "exit_confirm_yes": "Ja",
      "exit_confirm_no": "Nej",
      "unsaved_changes_header": "Osparade ändringar",
      "unsaved_changes_body": "Du har osparade resultat för detta hål. Vill du fortsätta utan att spara eller återgå till sparandet?",
      "unsaved_changes_save": "Återgå till sparandet",
      "unsaved_changes_continue": "Fortsätt utan att spara",
      "saving": "Sparar...",
      "not_started": "Inte påbörjad",
      "save_scores": "Spara resultat",
      "review_scorecard": "Granska och signera resultatkort",
      "overwrite_confirm_title": "Du håller på att ändra resultatet för hålet",
      "overwrite_confirm_notification_warning": "Ändringen meddelas till övriga spelare!",
      "overwrite_confirm_old_score": "Gammalt resultat",
      "overwrite_confirm_new_score": "Nytt resultat",
      "overwrite_confirm_removed": "borttaget",
      "notification_title": "Resultat ändrade",
      "notification_changed_score": "{{changedBy}} ändrade spelarens {{playerName}} resultat för hål {{hole}}",
      "notification_old_new": "Gammalt: {{old}} → Nytt: {{new}}",
      "notification_score_removed": "borttaget",
      "notification_ok": "OK",
      "notification_changed_score_team": "{{changedBy}} ändrade lag {{playerName}}s resultat på hål {{hole}}",
      "status_short_dq": "DQ",
      "status_short_wd": "WD",
      "overwrite_confirm_player_label": "Spelare",
      "overwrite_confirm_score_label": "Resultat",
      "notification_change_label": "Ändring",
      "notification_edited_by": "Redigerades av {{changedBy}}",
      "notification_changed_result": "ändrade resultatet"
    },
    "playing_handicap_tooltip": "Spelhandikapp: {{value}}",
    "ties_broken_by": "Avgörande vid lika resultat",
    "using_default_draw_decision": "Standardvärde används: delade placeringar, matematisk ordning",
    "no_explicit_config": "Inte definierat för denna resultattyp",
    "primary_short": "Primär",
    "secondary_short": "Sekund.",
    "system36Handicap": "HCP"
  },
  "participation": {
    "searchPlayer": "Sök spelare",
    "allClubs": "Alla klubbar",
    "nameOrMemberNumber": "Namn eller medlemsnummer",
    "search": "Sök",
    "noResults": "Inga resultat",
    "already_registered": "Anmäld",
    "localPlayers": "Andra Impact-användare",
    "localSearchPlaceholder": "Sök med namn eller e-post",
    "allPlayers": "Alla spelare",
    "societyMembers": "Gemenskapens medlemmar",
    "selectSocietyMember": "Välj eller sök medlem"
  },
  "participations": {
    "pdf_columns": "Välj kolumner",
    "export_pdf": "Ladda ned PDF"
  },
  "pdf": {
    "filename_start_list": "startlista",
    "filename_participants": "deltagare",
    "filename_results": "resultat",
    "filename_team_results": "lag",
    "filename_individual_results": "individ"
  },
  "timeSchedule": {
    "templates": "Målschemallar",
    "addTemplate": "Lägg till mall",
    "createTemplate": "Skapa målschema",
    "editTemplate": "Redigera målschema",
    "templateName": "Schemats namn",
    "templateNamePlaceholder": "T.ex. Normal runda - helg",
    "expectedTimePerHole": "Tid per hål (minuter)",
    "description": "Beskrivning",
    "descriptionPlaceholder": "Beskrivning av schemat...",
    "selectScorecard": "Välj resultatkort",
    "selectScorecardPlaceholder": "Välj resultatkort...",
    "selectCourse": "Välj bana",
    "selectCoursePlaceholder": "Välj bana...",
    "holeTime": "Hål {{number}}",
    "hole": "Hål",
    "totalTime": "Måltid 18 hål",
    "totalExpectedTime": "Total måltid",
    "minutes": "min",
    "applyToAll": "Ange för alla",
    "applyToAllHint": "Ange samma tid för alla hål",
    "noTemplates": "Inga schemamallar",
    "noTemplatesMessage": "Skapa din första schemamall för att definiera förväntad speltid per hål.",
    "createFirst": "Skapa första mallen",
    "loadingTemplates": "Laddar mallar...",
    "failedToLoad": "Laddning av mallar misslyckades",
    "templateCreated": "Schemamall skapad",
    "templateUpdated": "Schemamall uppdaterad",
    "templateDeleted": "Schemamall borttagen",
    "createFailed": "Skapande av mall misslyckades",
    "updateFailed": "Uppdatering av mall misslyckades",
    "deleteFailed": "Borttagning av mall misslyckades",
    "confirmDelete": "Är du säker på att du vill ta bort mallen \"{{name}}\"?",
    "deleteTemplate": "Ta bort mall",
    "deleteSuccess": "Mall borttagen",
    "updateSuccess": "Mall uppdaterad",
    "createSuccess": "Mall skapad",
    "saveTemplate": "Spara mall",
    "cancel": "Avbryt",
    "holes": "{{count}} hål",
    "holeCount": "{{count}} hål",
    "holesHeader": "Hål",
    "course": "Bana",
    "manageTemplates": "Hantera schemamallar",
    "manageDescription": "Skapa och hantera schemamallar som kan användas för speltempospårning under rundor.",
    "frontNine": "Hål 1-9",
    "backNine": "Hål 10-18",
    "frontNineTime": "Utnionstid",
    "backNineTime": "Innionstid",
    "searchTemplates": "Sök schemamallar",
    "duration": "Längd",
    "out": "Ut",
    "in": "In",
    "errors": {
      "nameRequired": "Mallnamn krävs",
      "scorecardRequired": "Bana krävs",
      "invalidTime": "Alla hålstider måste vara minst 1 minut",
      "saveFailed": "Sparande av mall misslyckades",
      "loadFailed": "Laddning av mallar misslyckades",
      "deleteFailed": "Borttagning av mall misslyckades"
    }
  },
  "timeTracking": {
    "title": "Speltempospårning",
    "enableTracking": "Aktivera speltempospårning",
    "selectTemplate": "Välj schemamall",
    "selectTemplatePlaceholder": "Välj mall...",
    "noTemplate": "Ingen mall vald",
    "warningThreshold": "Varningsgräns (minuter)",
    "warningThresholdHelp": "Visa varning när gruppen ligger detta antal minuter efter schemat",
    "dangerThreshold": "Kritisk gräns (minuter)",
    "dangerThresholdHelp": "Visa kritisk varning när gruppen ligger detta antal minuter efter schemat",
    "overrideEnabled": "Åsidosätt spårning",
    "overrideReason": "Orsak till åsidosättning",
    "overrideReasonPlaceholder": "Ange varför schemaspårning är åsidosatt, t.ex. väderförhållanden...",
    "noTrackingConfigured": "Speltempospårning är inte konfigurerad för denna tävling.",
    "configureTracking": "Konfigurera spårning",
    "trackingEnabled": "Spårning aktiverad",
    "trackingDisabled": "Spårning inaktiverad",
    "saveSuccess": "Speltempospårning sparad",
    "deleteSuccess": "Speltempospårning borttagen",
    "saveFailed": "Sparande av speltempospårning misslyckades",
    "deleteFailed": "Borttagning av speltempospårning misslyckades",
    "confirmDelete": "Är du säker på att du vill ta bort speltempospårningen för denna tävling?",
    "removeTracking": "Ta bort spårning",
    "templateInfo": "Mall: {{name}}",
    "expectedTime": "Förväntad speltid: {{time}}",
    "thresholds": "Tröskelväden",
    "settings": "Inställningar"
  },
  "paceOfPlay": {
    "warningMessage": "Speltempovarning",
    "dangerWarning": "Speltempo kritiskt!",
    "behindSchedule": "{{minutes}} minuter efter schemat",
    "aheadSchedule": "{{minutes}} minuter före schemat",
    "onPace": "I fas med schemat",
    "status": {
      "onPace": "I fas med schemat",
      "catchingUp": "Håller på att hinna ifatt",
      "warning": "Varning - för långsamt tempo",
      "danger": "Kritiskt - mycket långsamt tempo"
    },
    "gap": {
      "rootCause": "Orsakar fördröjning",
      "gapToGroupAhead": "Avstånd till gruppen framför",
      "expectedGap": "Förväntat avstånd",
      "actualGap": "Faktiskt avstånd",
      "unavailable": "Spårning ej tillgänglig",
      "noGroupAhead": "Första starten",
      "minutes": "{{minutes}} min"
    },
    "tracking": {
      "enabled": "Spårning aktiv",
      "disabled": "Spårning inaktiv",
      "holesCompleted": "{{holes}} hål spelade"
    }
  },
  "payment": {
    "success_title": "Betalning genomförd",
    "success_message": "Din anmälan är bekräftad.",
    "cancelled_title": "Betalning avbruten",
    "cancelled_message": "Betalningen genomfördes inte. Du kan försöka igen.",
    "back_to_competitions": "Tillbaka till tävlingar",
    "fee_label": "Deltagaravgift",
    "pay_now": "Betala nu",
    "complete_payment": "Genomför betalning",
    "paid": "Betald",
    "failed_required_title": "Betalningen misslyckades",
    "failed_required_message": "Betalningen genomfördes inte, så registreringen slutfördes inte. Du kan försöka igen.",
    "failed_voluntary_title": "Betalningen misslyckades",
    "failed_voluntary_message": "Din registrering är genomförd, men betalningen slutfördes inte. Du kan betala senare eller försöka igen nu.",
    "retry_payment": "Försök betala igen",
    "retry_registration": "Försök registrera igen",
    "back_to_round_start": "Återgå till rundans start",
    "pay_later": "Betala senare"
  },
  "weekly": {
    "competition": "Veckotävling",
    "score_details_for": "Resultat för spelare",
    "no_competitions": "Inga veckotävlingar tillgängliga",
    "loading_competitions": "Laddar veckotävlingar...",
    "failed_to_load_competitions": "Laddning av veckotävlingar misslyckades",
    "register_for_competition": "Anmäl dig till veckotävling",
    "registered_competitions": "Anmälningar till veckotävlingar",
    "view_results": "Visa resultat",
    "position": "#",
    "player": "Spelare",
    "rounds_played": "Rundor",
    "total_score": "Totalresultat",
    "best_scores": "Bästa",
    "rounds_counted": "Räknade",
    "all_scores": "Resultat",
    "actions": "Åtgärder",
    "view_details": "Visa resultat",
    "add_score": "Lägg till resultat",
    "date": "Datum",
    "course": "Bana",
    "tee_set": "Tee",
    "strokes": "Slag",
    "stableford_points": "Poäng",
    "delete": "Ta bort resultat",
    "delete_score_title": "Ta bort resultat",
    "no_scores_submitted": "Inga resultat inlämnade ännu",
    "confirm_delete_score": "Är du säker på att du vill ta bort detta resultat?",
    "score_deleted": "Resultat borttaget",
    "deleting": "Tar bort...",
    "view_scorecard": "Visa resultatkort",
    "admin_score_entry": "Lägg till resultat",
    "not_weekly_competition": "Detta är inte en veckotävling",
    "no_results": "Inga resultat",
    "insufficient_rounds": "Otillräckligt antal rundor",
    "status": "Status",
    "ebirdie_sent_tooltip": "Skickad till eBirdie {{date}}, id: {{id}}",
    "series": "Serie",
    "payment_required_pill": "Betalning krävs",
    "payment_voluntary_pill": "Betalning frivillig"
  },
  "tvLeaderboard": {
    "page": "Sida {{current}} / {{total}}",
    "updated": "Uppdaterad: {{time}}",
    "rank": "PL",
    "player": "SPELARE",
    "leaderScore": "LEDANDE",
    "total": "TOT",
    "today": "IDAG",
    "thru": "SPELADE",
    "round": "R",
    "finished": "F",
    "withdrawn": "WD",
    "disqualified": "DQ",
    "loading": "Laddar resultattavla...",
    "error_title": "Resultattavlan kunde inte laddas",
    "no_data": "Ingen data tillgänglig",
    "missing_params": "Obligatoriska URL-parametrar: seriesId, roundIds",
    "hole": "#",
    "out": "Ut",
    "in": "In",
    "strokes": "Tot",
    "par": "PAR",
    "live": "LIVE",
    "flights_not_published": "Starter har inte publicerats",
    "enterFullscreen": "Gå till helskärmsläge",
    "exitFullscreen": "Avsluta helskärmsläge"
  },
  "handicap_recommendations": {
    "title": "Golfförbundets rekommendationer",
    "disclaimer": "Dessa är Finlands Golfförbunds rekommendationer för spelhandikapp. Du kan använda dem som de är, anpassa dem eller ange egna värden.",
    "multiple_found": "Flera rekommendationer hittades. Välj det lämpligaste alternativet.",
    "button_label": "Rekommendationer",
    "button_title": "Visa Golfförbundets rekommendationer",
    "apply": "Använd",
    "handicap_factor": "Handikapfaktor",
    "team_percentages": "Lagets %",
    "men_max": "Herrar max",
    "women_max": "Damer max"
  },
  "player_view": {
    "tabs": {
      "info": "Info",
      "participants": "Deltagare",
      "flights": "Starter",
      "results": "Resultat",
      "bracket": "Schema",
      "ryder_cup": "Lagmatch"
    },
    "status": {
      "registered": "Anmäld",
      "waitlisted": "På väntelista"
    },
    "register": "Anmäl dig till tävlingen",
    "join_waitlist": "Anmäl dig till väntelistan",
    "leave_waitlist": "Lämna väntelistan",
    "cancel_registration": "Avboka anmälan",
    "cancel_confirm_header": "Avboka anmälan",
    "cancel_confirm_body": "Är du säker på att du vill avboka din anmälan?",
    "leave_waitlist_confirm_header": "Lämna väntelistan",
    "leave_waitlist_confirm_body": "Är du säker på att du vill lämna väntelistan?",
    "waitlist_cancelled_success": "Du har lämnat väntelistan",
    "registration_cancelled_success": "Din anmälan har avbokats",
    "open_live_scoring": "Öppna Live Scoring",
    "info": {
      "pay_competition_fee": "Betala tävlingsavgift",
      "competition_invitation": "Tävlingsinbjudan",
      "date": "Tidpunkt",
      "registration": "Anmälan",
      "registration_closed": "Anmälan avslutad",
      "invite_only": "Inbjudningstävling",
      "participant_count": "Antal deltagare",
      "competition_info": "Tävlingsinfo",
      "prices": "Priser",
      "no_eligible_series": "Du kan inte anmäla dig till tävlingen eftersom ingen lämplig serie hittades för dig.",
      "restriction_not_met": "Du uppfyller inte registreringskraven.",
      "restriction": {
        "EBIRDIE_MEMBERS": "Registreringen är begränsad till Golfförbundets medlemmar.",
        "HOME_CLUB_MEMBERS": "Registreringen är begränsad till hemmaklubbens spelare.",
        "SELECTED_CLUBS": "Registreringen är begränsad till spelare från valda klubbar.",
        "SOCIETY_MEMBERS": "Registreringen är begränsad till sällskapets medlemmar."
      },
      "your_match": "Din match",
      "match_opponent": "Motståndare",
      "match_round": "Runda",
      "match_status": "Status",
      "match_tee_time": "Starttid",
      "match_hole": "Hål",
      "no_eligible_series_weekly": "Du kan inte registrera ett resultat eftersom ingen lämplig serie hittades för dig."
    },
    "participants": {
      "header": "Deltagare",
      "club": "Klubb",
      "hcp": "HCP",
      "no_participants": "Inga deltagare"
    },
    "flights": {
      "not_published": "Starter har inte publicerats",
      "tee": "Tee",
      "time": "Tid",
      "name": "Namn",
      "club": "Klubb",
      "slope": "Slope",
      "round": "Runda",
      "no_flights": "Inga starter",
      "enter_scores": "Ange resultat",
      "startHole": "Hål",
      "player": "Spelare",
      "team": "Lag"
    },
    "results": {
      "par": "PAR",
      "score": "Resultat",
      "net": "NET",
      "finished": "F",
      "no_results": "Inga resultat",
      "hole": "Hål",
      "out": "UT",
      "in": "IN",
      "series": "Serie",
      "round": "Runda",
      "my_flight": "Mitt startfält",
      "all_players": "Alla spelare",
      "points": "Pts",
      "played_abbrev": "SPE",
      "total_abbrev": "TOT"
    },
    "registration": {
      "title": "Tävlingsanmälan",
      "select_series": "Välj serie",
      "start_time_preference": "Starttidsönskemål",
      "start_time_early": "Tidig",
      "start_time_late": "Sen",
      "notes": "Ytterligare information",
      "notes_guideline": "Max. 180 tecken",
      "notes_placeholder": "Ytterligare information (max. 180 tecken)",
      "back": "Tillbaka",
      "next": "Nästa",
      "register": "Anmäl dig",
      "continue": "Fortsätt",
      "terms_title": "Anmälningsvillkor",
      "terms_prompt": "Godkänner du villkoren",
      "terms_reject": "Nej, avvisa",
      "terms_accept": "Ja, godkänner",
      "confirmed_title": "Anmäld",
      "waitlisted_title": "På väntelista",
      "withdrawn_title": "Anmälan avbruten",
      "confirmed_message": "Anmälan genomfördes!",
      "waitlisted_message": "Du har lagts till på väntelistan!",
      "withdrawn_message": "Din anmälan har avbrutits.",
      "back_to_competition": "Tillbaka till tävlingen",
      "spots_remaining": "{{count}} platser kvar",
      "series_full": "Serien är full",
      "waitlist_available": "Väntelista möjlig",
      "error": "Anmälan misslyckades",
      "birthdate_required": "Serierna har åldersgränser. Du har inte angett något födelsedatum.",
      "set_birthdate": "Ange födelsedatum",
      "save_birthdate": "Spara",
      "payment_title": "Betalning",
      "paid_title": "Betald",
      "payment_fee_item": "1 x {{feeName}}",
      "payment_total_label": "Belopp att debitera",
      "payment_secure": "Säker betalning",
      "payment_paytrail": "Paytrail är ett inhemskt",
      "payment_pay_later": "Betala senare",
      "payment_go_to_pay": "Gå till betalning",
      "payment_error": "Betalningen kunde inte påbörjas. Försök igen senare.",
      "payment_fee_item_team": "{{count}} x {{feeName}}",
      "payment_per_player": "/ spelare",
      "payment_select_players": "Välj vem du betalar för",
      "payment_partial_warning": "Spelare som inte betalas nu kan betala senare",
      "team_name": "Lagnamn",
      "team_name_placeholder": "Ange lagnamn",
      "players_count": "Spelare {{count}}/{{max}}",
      "search_placeholder": "Namn eller medlemsnummer",
      "search_club": "Klubb",
      "search_button": "Sök",
      "search_results": "Sökresultat",
      "search_add": "Lägg till",
      "search_close": "Stäng",
      "search_no_results": "Inga sökresultat",
      "register_partial_team": "Anmäl ofullständigt lag",
      "player_already_registered": "Spelaren är redan anmäld",
      "player_ineligible_gender": "Spelaren uppfyller inte seriens könskriterium",
      "player_ineligible_age": "Spelaren uppfyller inte seriens ålderskrav",
      "player_ineligible_handicap": "Spelarens handikapp är inte inom seriens tillåtna intervall",
      "player_already_added": "Spelaren är redan tillagd i laget",
      "payment_select_fee": "Välj pris",
      "payment_select_fee_per_player": "Välj betalning för spelarna",
      "terms_body": "Jag godkänner registreringsvillkoren, registreringens bindande karaktär samt den därtill hörande debiteringen av tävlingsavgiften.",
      "payment_member_already_paid": "Betald",
      "payment_all_members_paid": "Alla lagmedlemmar har betalat",
      "event_title": "Evenemangsregistrering",
      "terms_body_event": "Jag godkänner registreringsvillkoren, registreringens bindande karaktär samt den tillhörande evenemangsavgiften.",
      "birthdate_card_title": "Lägg till födelsedatum",
      "birthdate_card_subtitle": "Serierna har åldersgränser",
      "birthdate_card_action": "Ange",
      "birthdate_modal_title": "Ange födelsedatum",
      "birthdate_modal_field_label": "Födelsedatum",
      "birthdate_modal_placeholder": "DD.MM.ÅÅÅÅ",
      "cart_wish_label": "Jag vill ha golfbil",
      "cart_wish_checkbox_title": "Golfbil",
      "cart_wish_default_info": "Kontrollera tillgängligheten av golfbilar hos caddiemastaren"
    },
    "open_scoring": "Öppna resultatinmatning",
    "register_event": "Registrera dig till evenemanget",
    "open_scoring_weekly": "Ange resultat",
    "bracket": {
      "not_published": "Schemat har inte publicerats"
    }
  },
  "waitlist": {
    "modal": {
      "title": "Tävlingen är full",
      "body": "{{competitionName}} är full. Vill du gå med på väntelistan?",
      "accept": "Ja, gå med på väntelistan",
      "decline": "Avbryt"
    },
    "declined_message": "Registreringen avbröts. Tävlingen är full och väntelistan accepterades inte."
  },
  "not_public_banner": {
    "text": "Evenemanget är inte offentligt. Spelare ser inte detta evenemang i tävlingskalendern.",
    "publish_link": "Publicera.",
    "publish_success": "Evenemanget publicerades",
    "publish_failed": "Publicering misslyckades",
    "textSociety": "Evenemanget har inte publicerats ännu. Medlemmar kan inte se detta evenemang före publicering."
  },
  "ebirdie": {
    "submit": "Skicka till eBirdie",
    "cancel_submission": "Avbryt eBirdie-sändning",
    "submit_success": "{{count}} resultat skickade till eBirdie",
    "submit_skipped": "{{count}} resultat uppfyller inte sändningsvillkoren",
    "submit_failed": "Sändning av {{count}} resultat misslyckades",
    "no_results": "Inga resultat att skicka",
    "submit_error": "eBirdie-sändning misslyckades",
    "status_submitted": "Skickat till eBirdie",
    "status_queued": "Väntar på sändning till eBirdie",
    "status_failed": "eBirdie-sändning misslyckades",
    "cancel_confirm_title": "Avbryt eBirdie-sändning",
    "cancel_confirm_body": "Vill du verkligen avbryta eBirdie-sändningen för alla resultat? eBirdie kan avvisa avbokningar som är äldre än 7 dagar.",
    "cancel_confirm_button": "Avbryt sändning",
    "cancel_success": "eBirdie-sändning avbruten för {{count}} resultat",
    "cancel_skipped": "{{count}} resultat hoppades över",
    "cancel_failed": "Avbrytning av {{count}} resultat misslyckades",
    "cancel_error": "Avbrytning av eBirdie-sändning misslyckades",
    "submit_selected": "Exportera valda ({{count}}) till eBirdie",
    "cancel_selected": "Avbryt valda ({{count}})"
  },
  "coming_soon": "Kommer snart",
  "public_calendar": {
    "page_title": "Tävlingskalender",
    "tenant_not_found": "Klubben hittades inte",
    "meta_description": "{{club}} tävlingskalender – alla kommande golftävlingar",
    "login": "Logga in",
    "empty": "Inga offentliga tävlingar"
  },
  "scorecard_review": {
    "title": "Granskning av resultatkort",
    "back_to_scoring": "Tillbaka till resultatinmatning",
    "close": "Stäng och återgå till huvudsidan",
    "previous_player": "Föregående spelare",
    "next_player": "Nästa spelare",
    "return_to_scoring": "Återgå till resultatinmatning",
    "confirm_and_sign": "Bekräfta och signera",
    "conflict_warning": "Den här spelaren har konflikter som har lösts automatiskt",
    "all_holes_required": "Resultat för alla hål måste anges innan signering",
    "conflicts_must_be_resolved": "Alla konflikter måste lösas innan signering",
    "confirm_title": "Bekräfta och signera resultatkortet",
    "confirm_message": "Är du säker på att du vill signera resultatkortet?\n\nEfter signering kan resultaten inte längre ändras från spelarvy. Ändringar kräver administratörsåtgärder.",
    "cancel": "Avbryt",
    "sign": "Signera",
    "signing_error": "Fel vid signering av resultat. Försök igen.",
    "no_results": "Inga resultat hittades",
    "signing_processing": "Signerar...",
    "signing_done": "Signerat.",
    "sign_player": "Signera resultatkort",
    "unsign_player": "Ångra signering",
    "confirm_sign_player": "Vill du verkligen signera spelarens {{playerName}} resultatkort?",
    "signed_badge": "Signerat",
    "unsign_error": "Fel vid ångrande av signering. Försök igen.",
    "player_holes_required": "Resultat för alla hål måste anges innan signering",
    "player_conflicts": "Spelaren har olösta konflikter",
    "all_signed_title": "Resultatkort signerade",
    "all_signed_description": "Om du vill göra ändringar i resultatkorten, kontakta tävlingens arrangörer",
    "all_signed_close": "Stäng"
  },
  "eligible_series_singular": "Serie",
  "series_options_count": "{{count}} alternativ",
  "choose_series": "Välj serie",
  "special_competitions": {
    "section": {
      "title": "Specialtävlingar",
      "add": "Lägg till specialtävling",
      "empty": "Den här rundan har inga specialtävlingar.",
      "save_first_hint": "Spara rundan innan du lägger till specialtävlingar.",
      "history": "Resultat",
      "load_error": "Det gick inte att ladda specialtävlingarna.",
      "delete_error": "Det gick inte att ta bort specialtävlingen.",
      "confirm_delete_header": "Ta bort specialtävling",
      "confirm_delete_body": "Är du säker på att du vill ta bort den här specialtävlingen? Alla tillhörande noteringar tas också bort."
    },
    "form": {
      "title_add": "Lägg till specialtävling",
      "title_edit": "Redigera specialtävling",
      "name": "Namn",
      "hole_number": "Hålnummer",
      "unit": "Enhet",
      "unit_placeholder": "t.ex. m, cm, yd",
      "direction": "Vinnare",
      "direction_none": "Senaste registrering",
      "direction_max_wins": "Högsta värde",
      "direction_min_wins": "Lägsta värde"
    },
    "direction": {
      "MAX_WINS": "Högsta värde",
      "MIN_WINS": "Lägsta värde"
    },
    "history": {
      "title": "Specialtävlingens resultat: {{name}}",
      "title_generic": "Specialtävlingens resultat",
      "player": "Spelare",
      "value": "Resultat",
      "submitted_by": "Noterad av",
      "submitted_at": "Tid",
      "empty": "Inga noteringar.",
      "load_error": "Det gick inte att ladda resultaten.",
      "delete_error": "Det gick inte att ta bort noteringen.",
      "confirm_delete_header": "Ta bort notering",
      "confirm_delete_body": "Är du säker på att du vill ta bort den här noteringen? Den föregående noteringen blir ny ledare.",
      "add_record_submit": "Spara resultat",
      "add_record_participant_label": "Spelare",
      "add_record_value_label": "Resultat",
      "add_record_load_error": "Inläsning av spelare misslyckades",
      "add_record_submit_error_default": "Sparande av resultat misslyckades",
      "add_record_participant_placeholder": "Sök spelare...",
      "add_record_no_options": "Inga spelare"
    },
    "results": {
      "title": "Specialtävlingar",
      "no_leader": "Inga resultat"
    },
    "pdf": {
      "column_hole": "Hål",
      "column_name": "Tävling",
      "column_leader": "Ledare",
      "column_value": "Resultat",
      "no_leader_yet": "-"
    },
    "panel": {
      "card": {
        "no_leader": "Inga resultat",
        "set_button": "Ange",
        "change_button": "Ändra"
      },
      "modal": {
        "eyebrow": "Hål {{hole}} - Extra tävling",
        "help_with_unit": "Välj spelare och ange mått.",
        "help_no_value": "Välj spelare.",
        "value_label": "Mått ({{unit}})",
        "submit": "Spara",
        "cancel": "Avbryt",
        "cancel_record": "Ta bort post",
        "cancel_confirm": {
          "title": "Ta bort post?",
          "confirm": "Ta bort post",
          "dismiss": "Stäng"
        }
      }
    }
  },
  "publicRankings": {
    "page_title": "Ranking",
    "empty_state": "Inga publicerade rankingserier för detta år",
    "year_filter_label": "År",
    "back_to_list": "Tillbaka"
  },
  "competitions": {
    "public_view": {
      "linked_ranking_series_label": "Rankingserier"
    }
  },
  "competition_form": {
    "categories_label": "Kategorier",
    "categories_placeholder": "Välj kategorier..."
  },
  "categories": {
    "title": "Kategorier",
    "create": "Lägg till kategori",
    "edit_category": "Redigera kategori",
    "name_label": "Kategorinamn",
    "slug_label": "URL-identifierare",
    "url_label": "Sidans adress",
    "url_help_immutable": "Adressen skapas automatiskt från namnet och kan inte ändras i efterhand.",
    "open_url": "Öppna i ny flik",
    "url_preview_label": "Adress:",
    "url_preview_empty": "(ges baserat på namnet)",
    "edit": "Redigera",
    "delete": "Ta bort",
    "delete_confirm_title": "Ta bort kategori?",
    "delete_confirm_body": "Den här kategorin är kopplad till {{count}} tävlingar. Borttagningen tar bort kategoriidentifieraren från dessa tävlingar, men själva tävlingarna bevaras. Vill du fortsätta?",
    "filter_label": "Filtrera efter kategori",
    "filter_all_option": "Alla kategorier",
    "empty_state_for_category": "Inga tävlingar i kategorin {{category}} år {{year}}.",
    "no_categories_yet": "Inga kategorier",
    "empty_state_help": "Med kategorier grupperar du tävlingar, och spelare kan filtrera dem i evenemangskalendern.",
    "duplicate_name_error": "En kategori med samma namn finns redan.",
    "duplicate_slug_error": "Den här URL-identifieraren används redan.",
    "created_success": "Kategori skapad",
    "updated_success": "Kategori uppdaterad",
    "deleted_success": "Kategori borttagen",
    "failed_to_load": "Det gick inte att läsa in kategorier",
    "failed_to_save": "Det gick inte att spara",
    "failed_to_delete": "Det gick inte att ta bort"
  },
  "subCompetitions": {
    "tab_label": "Lagtävling",
    "game_type_label": "Spelform",
    "best_ball": "Bästa boll",
    "formation_label": "Lagbildning",
    "formation_flight": "Enligt startgrupp",
    "formation_club": "Enligt klubb",
    "formation_manual": "Manuell",
    "counting_scores_label": "Resultat per lag",
    "team_column": "Lag",
    "no_club": "Ingen klubb",
    "resultTypes": {
      "STROKEPLAY_SCRATCH": "Slagspel Scratch",
      "STROKEPLAY_HCP": "Slagspel HCP",
      "STABLEFORD_SCRATCH": "Stableford Scratch",
      "STABLEFORD_HCP": "Stableford HCP",
      "MAXIMUMSCORE_SCRATCH": "Maxresultat Scratch",
      "MAXIMUMSCORE_HCP": "Maxresultat HCP",
      "SYSTEM36": "System 36"
    },
    "manual": {
      "load_failed": "Det gick inte att ladda lagdata. Försök igen.",
      "no_participants_heading": "Inga bekräftade deltagare",
      "no_participants_body": "Lag kan inte bildas eftersom det inte finns några bekräftade deltagare ännu.",
      "go_to_participants": "Gå till deltagare →",
      "all_placed_heading": "Alla spelare placerade",
      "all_placed_body": "Varje deltagare tillhör ett lag. Du kan frigöra en spelare genom att ta bort dem från laget.",
      "col_player": "SPELARE",
      "col_club": "KLUBB",
      "col_handicap": "HANDICAP",
      "form_team_button": "Bilda lag →",
      "no_teams_heading": "Inga lag ännu",
      "no_teams_body": "Välj spelare från vänster och tryck på Bilda lag. Du kan namnge laget efter att det bildats.",
      "default_team_name": "Lag {{n}}",
      "rename_tooltip": "Byt namn",
      "delete_team_tooltip": "Ta bort lag",
      "remove_player_tooltip": "Ta bort från lag",
      "rename_placeholder": "Lagets namn",
      "rename_save_tooltip": "Spara namn",
      "rename_cancel_tooltip": "Avbryt namnbyte",
      "edit_teams_button": "Redigera lag",
      "teams_header": "LAG",
      "status_placed": "placerad",
      "results_button": "Resultat",
      "formation_save_failed": "Det gick inte att spara formationen. Försök igen.",
      "create_failed": "Det gick inte att skapa laget. Försök igen.",
      "rename_failed": "Det gick inte att byta namn på laget. Försök igen.",
      "delete_failed": "Det gick inte att ta bort laget. Försök igen.",
      "remove_member_failed": "Det gick inte att ta bort spelaren. Försök igen.",
      "confirm_delete_title": "Ta bort lag",
      "confirm_delete_body": "Detta tar bort laget och påverkar resultaten. Vill du fortsätta?",
      "confirm_remove_title": "Ta bort spelare från lag",
      "confirm_remove_body": "Detta tar bort spelaren från laget och påverkar resultaten. Vill du fortsätta?"
    }
  },
  "remove_theme_color": "Ta bort temafärg"
}
